import React from 'react'
import { Stack } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs, { Dayjs } from 'dayjs'
import CommentsViewFilterField from './CommentsViewFilterField'

type CommentsViewDateRangeFiltersProps = {
    from: string | null
    to: string | null
    onFromChange: (value: string | null) => void
    onToChange: (value: string | null) => void
}

const getPickerSx = () => ({
    borderRadius: '16px',
    '& .MuiOutlinedInput-root': {
        borderRadius: '16px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important',
        borderColor: 'figma.grayscale.stroke !important',
    },
    '& .MuiInputBase-input': {
        p: 2,
        color: 'figma.primary',
        fontSize: '16px',
        fontWeight: 600,
        height: 'auto',
        fontFamily: 'acumin-pro !important',
    },
    '& .MuiInputBase-input::placeholder': {
        color: 'figma.primary',
        opacity: 1,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'figma.grayscale.tier5 !important',
    },
    '& .MuiIconButton-root': {
        color: 'figma.grayscale.tier2',
        mr: 0.5,
    },
    '& .MuiSvgIcon-root': {
        fontSize: '20px',
    },
})

const formatDateValue = (value: Dayjs | null) => (value?.isValid() ? value.startOf('day').format('YYYY-MM-DD') : null)

const CommentsViewDateRangeFilters = ({ from, to, onFromChange, onToChange }: CommentsViewDateRangeFiltersProps) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction={{ xs: 'column', md: 'row' }} gap={3} flexWrap="wrap">
                <CommentsViewFilterField label="From" isActive={!!from} onClear={() => onFromChange(null)}>
                    <DatePicker
                        value={from ? dayjs(from) : null}
                        onChange={(value) => onFromChange(formatDateValue(value))}
                        maxDate={to ? dayjs(to) : undefined}
                        format="MM/DD/YYYY"
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                placeholder: 'MM/DD/YYYY',
                            },
                        }}
                        sx={getPickerSx()}
                    />
                </CommentsViewFilterField>
                <CommentsViewFilterField label="To" isActive={!!to} onClear={() => onToChange(null)}>
                    <DatePicker
                        value={to ? dayjs(to) : null}
                        onChange={(value) => onToChange(formatDateValue(value))}
                        minDate={from ? dayjs(from) : undefined}
                        format="MM/DD/YYYY"
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                placeholder: 'MM/DD/YYYY',
                            },
                        }}
                        sx={getPickerSx()}
                    />
                </CommentsViewFilterField>
            </Stack>
        </LocalizationProvider>
    )
}

export default CommentsViewDateRangeFilters
